// @flow

import styled from 'styled-components';
import type { Theme } from '@types/index';

export default styled<any, Theme>('section')`
  margin-bottom: 2.25rem;
`;
